import { http, HttpResponse } from 'msw';
import { getDynamicUrl } from '../middleware/lokaliseUrlMiddleware';

const responseRate = http.get(`${getDynamicUrl(process.env.URL_BFF)}/users/:id`, ({ params }) => {
    const { id } = params;

    console.log(`Fetching user from BFF with ID ${id}`);

    const reactivityLevels = ['LOW', 'GREAT', 'AVERAGE', 'EXCELLENT'];
    const randomIndex = Math.floor(Math.random() * reactivityLevels.length);

    return HttpResponse.json({ id, reactivity_level: reactivityLevels[randomIndex] });
});

const responseTime = http.get(`${process.env.URL_API}/v1/users/:id/response/time`, ({ params }) => {
    const { id } = params;

    console.log(`Fetching user response time with ID ${id}`);

    const randomIsNewUser = Math.random() < 0.5;
    const randomResponseTime = Math.floor(Math.random() * 120);

    return HttpResponse.json({ is_new_user: randomIsNewUser, response_time: randomResponseTime });
});

const handlers = [responseRate, responseTime];

export { handlers };
